import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SideBarDockingService {
  private sideBarToggled = new BehaviorSubject<string>('');

  constructor() { }

  emitSideBarToggled(tag: string){
    this.sideBarToggled.next(tag)
 }

 sideBarToggleEventListner(){
    return this.sideBarToggled.asObservable();
  }
}
